import { IconProps } from "./types";

export default function IcoWifi({
	color = "#4B5563",
	width = "20",
	height = "16"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 20 16"
			fill="none"
		>
			<path d="M20 16H0V0H20V16Z" stroke="#E5E7EB" />
			<path
				d="M1.69356 6.34062C3.84981 4.27187 6.77481 3 9.99981 3C13.2248 3 16.1498 4.27187 18.3061 6.34062C18.7061 6.72187 19.3373 6.70937 19.7186 6.3125C20.0998 5.91563 20.0873 5.28125 19.6904 4.9C17.1779 2.48438 13.7623 1 9.99981 1C6.23731 1 2.82168 2.48438 0.306058 4.89687C-0.0908168 5.28125 -0.103317 5.9125 0.277933 6.3125C0.659183 6.7125 1.29356 6.725 1.69043 6.34062H1.69356ZM9.99981 8C11.7748 8 13.3936 8.65938 14.6311 9.75C15.0467 10.1156 15.6779 10.075 16.0436 9.6625C16.4092 9.25 16.3686 8.61562 15.9561 8.25C14.3686 6.85 12.2811 6 9.99981 6C7.71856 6 5.63106 6.85 4.04668 8.25C3.63106 8.61562 3.59356 9.24688 3.95918 9.6625C4.32481 10.0781 4.95606 10.1156 5.37168 9.75C6.60606 8.65938 8.22481 8 10.0029 8H9.99981ZM11.9998 13C11.9998 12.4696 11.7891 11.9609 11.414 11.5858C11.0389 11.2107 10.5302 11 9.99981 11C9.46938 11 8.96067 11.2107 8.5856 11.5858C8.21052 11.9609 7.99981 12.4696 7.99981 13C7.99981 13.5304 8.21052 14.0391 8.5856 14.4142C8.96067 14.7893 9.46938 15 9.99981 15C10.5302 15 11.0389 14.7893 11.414 14.4142C11.7891 14.0391 11.9998 13.5304 11.9998 13Z"
				fill={color}
			/>
		</svg>
	);
}
